import { AxiosInstance } from "axios";
import { getBasePathHref } from "../shared/functions";

// Redirect loop guard: skip redirect if we already redirected within this window.
const REDIRECT_COOLDOWN_MS = 5_000;
let lastRedirectTimestamp = 0;

export const addUnauthorizedInterceptor = (instance: AxiosInstance): void => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const now = Date.now();
        if (now - lastRedirectTimestamp > REDIRECT_COOLDOWN_MS) {
          lastRedirectTimestamp = now;
          // Force reload to the deployment root (e.g. "/" in prod or
          // "/<pr-number>/" in preview) so we re-enter the auth flow on the
          // SAME deployment, not on the host's root path.
          window.location.href = getBasePathHref();
        }
      }
      return Promise.reject(error);
    },
  );
};
